import { cn } from '../../lib/utils';

/**
 * Область графика, которую можно растянуть по высоте ячейки сетки.
 *
 * От `xl`, внутри карточки с `flex-col`, область занимает всё свободное место, но не меньше
 * `height`; ниже `xl` — ровно `height`, как было до сетки. График лежит в абсолютном слое:
 * `ResponsiveContainer` с высотой 100% в обычном потоке раздувал бы строку сетки, а та — его,
 * и высота росла бы без конца.
 */
const PlotBox = ({ height, className, contentClassName, children }) => (
  <div
    className={cn(
      'relative w-full min-w-0 h-[var(--plot-height)] xl:h-auto xl:min-h-[var(--plot-height)] xl:flex-1',
      className
    )}
    style={{ '--plot-height': `${height}px` }}
  >
    <div className={cn('absolute inset-0', contentClassName)}>{children}</div>
  </div>
);

export default PlotBox;
